import { motion } from 'framer-motion'

// Utils
import { pageVariants } from 'components/interestform/utils'

import commonStyles from 'components/interestform/slides/common.css'
import styles from './thisissampling.css'

const ThisIsSampling = (): JSX.Element => {
  return (
    <motion.div className={commonStyles.wrapper} initial="initial" animate="in" exit="out" variants={pageVariants}>
      <div className={styles.dictionaryWrapper}>
        <div className={styles.dictionaryTitle}>sampling</div>
        <div className={styles.dictionarySubitle}>[ sam·pling | \ ˈsam-pliŋ ]</div>
        <hr />
        <em>noun</em>
        <div>
          <div className={styles.dictionaryContent}>
            <strong>sampling</strong> is the reuse of a portion (or sample) of a sound recording in another recording. Samples may comprise
            elements such as rhythm, melody, speech, sounds, or entire bars of music, and may be layered, equalized, sped up or slowed down,
            pitch-changed, looped, or otherwise manipulated.
          </div>
        </div>
        <hr />
        <cite className={styles.dictionarySource}>Wikipedia</cite>
      </div>
      <div className={commonStyles.textContent}>
        <div className={commonStyles.paragraph}>
          Sampling, an important part of music making for over 40 years, is an art form that has been heavily repressed by the complicated
          copyrights that surround original music. Due to the complexity, cost and time taken through traditional sampling processes, piracy
          has been common practice
        </div>
        <div className={commonStyles.paragraph}>
          Yet, as proof of its value and popularity among top artists - <strong>92% of 2020’s top producers sampled</strong> – and pretty
          much all producers with three or more credits in this year’s <strong>Billboard Hot 100</strong> used samples. The search for
          samples has grown into a whole cultural movement in itself, with beat culture and vinyl digging enthusiasts all over the world
          looking for unexplored gems of music
        </div>
      </div>
    </motion.div>
  )
}

export default ThisIsSampling
